import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { PaymentPageData } from '../../interfaces/payment-page/payment-page-data';

@Injectable({
  providedIn: 'root'
})
export class AdministrationToTableDataMapper {

  constructor() { }

  public map(paymentPageData: PaymentPageData): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'STATE',
        valueType: 'STATE',
        value: paymentPageData.status,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTPAGENAME',
        value: paymentPageData.name,
      },
    ];
  }
}
